import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  // 한자 단어 데이터 (분야별 100개씩, 예시로 일부만 표시)
  const hanjaData = {
    시사: [
      { hanja: "政府", sound: "정부", meaning: "정부" },
      { hanja: "政治", sound: "정치", meaning: "정치" },
      { hanja: "法律", sound: "법률", meaning: "법률" },
      { hanja: "國際", sound: "국제", meaning: "국제" },
      { hanja: "外交", sound: "외교", meaning: "외교" },
      { hanja: "行政", sound: "행정", meaning: "행정" },
      { hanja: "議會", sound: "의회", meaning: "의회" },
      { hanja: "選擧", sound: "선거", meaning: "선거" },
      { hanja: "民主", sound: "민주", meaning: "민주" },
      { hanja: "獨立", sound: "독립", meaning: "독립" },
      { hanja: "統制", sound: "통제", meaning: "통제" },
      { hanja: "政策", sound: "정책", meaning: "정책" },
      { hanja: "革命", sound: "혁명", meaning: "혁명" },
      { hanja: "權力", sound: "권력", meaning: "권력" },
      { hanja: "自由", sound: "자유", meaning: "자유" },
      { hanja: "平等", sound: "평등", meaning: "평등" },
      { hanja: "國家", sound: "국가", meaning: "국가" },
      { hanja: "市民", sound: "시민", meaning: "시민" },
      { hanja: "報道", sound: "보도", meaning: "보도" },
      { hanja: "新聞", sound: "신문", meaning: "신문" },
      { hanja: "輿論", sound: "여론", meaning: "여론" },
      { hanja: "宣傳", sound: "선전", meaning: "선전" },
      { hanja: "情報", sound: "정보", meaning: "정보" },
      { hanja: "事件", sound: "사건", meaning: "사건" },
      { hanja: "爭議", sound: "쟁의", meaning: "쟁의" },
      { hanja: "協定", sound: "협정", meaning: "협정" },
      { hanja: "制裁", sound: "제재", meaning: "제재" },
      { hanja: "和平", sound: "평화", meaning: "평화" },
      { hanja: "戰爭", sound: "전쟁", meaning: "전쟁" },
      { hanja: "軍事", sound: "군사", meaning: "군사" },
      { hanja: "防衛", sound: "방위", meaning: "방위" },
      { hanja: "安全", sound: "안전", meaning: "안전" },
      { hanja: "危機", sound: "위기", meaning: "위기" },
      { hanja: "援助", sound: "원조", meaning: "원조" },
      { hanja: "移民", sound: "이민", meaning: "이민" },
      { hanja: "難民", sound: "난민", meaning: "난민" },
      { hanja: "犯罪", sound: "범죄", meaning: "범죄" },
      { hanja: "裁判", sound: "재판", meaning: "재판" },
      { hanja: "監獄", sound: "감옥", meaning: "감옥" },
      { hanja: "警察", sound: "경찰", meaning: "경찰" },
      { hanja: "責任", sound: "책임", meaning: "책임" },
      { hanja: "義務", sound: "의무", meaning: "의무" },
      { hanja: "權利", sound: "권리", meaning: "권리" },
      { hanja: "腐敗", sound: "부패", meaning: "부패" },
      { hanja: "改革", sound: "개혁", meaning: "개혁" },
      { hanja: "發展", sound: "발전", meaning: "발전" },
      { hanja: "競爭", sound: "경쟁", meaning: "경쟁" },
      { hanja: "協力", sound: "협력", meaning: "협력" },
      { hanja: "對話", sound: "대화", meaning: "대화" },
      { hanja: "分裂", sound: "분열", meaning: "분열" },
      { hanja: "統合", sound: "통합", meaning: "통합" },
      { hanja: "地域", sound: "지역", meaning: "지역" },
      { hanja: "都市", sound: "도시", meaning: "도시" },
      { hanja: "農村", sound: "농촌", meaning: "농촌" },
      { hanja: "交通", sound: "교통", meaning: "교통" },
      { hanja: "建設", sound: "건설", meaning: "건설" },
      { hanja: "産業", sound: "산업", meaning: "산업" },
      { hanja: "資源", sound: "자원", meaning: "자원" },
      { hanja: "環境", sound: "환경", meaning: "환경" },
      { hanja: "災害", sound: "재해", meaning: "재해" },
      { hanja: "氣候", sound: "기후", meaning: "기후" },
      { hanja: "變化", sound: "변화", meaning: "변화" },
      { hanja: "対策", sound: "대책", meaning: "대책" },
      { hanja: "調査", sound: "조사", meaning: "조사" },
      { hanja: "統計", sound: "통계", meaning: "통계" },
      { hanja: "分析", sound: "분석", meaning: "분석" },
      { hanja: "予測", sound: "예측", meaning: "예측" },
      { hanja: "計劃", sound: "계획", meaning: "계획" },
      { hanja: "実行", sound: "실행", meaning: "실행" },
      { hanja: "結果", sound: "결과", meaning: "결과" },
      { hanja: "報告", sound: "보고", meaning: "보고" },
      { hanja: "討論", sound: "토론", meaning: "토론" },
      { hanja: "意見", sound: "의견", meaning: "의견" },
      { hanja: "提案", sound: "제안", meaning: "제안" },
      { hanja: "承認", sound: "승인", meaning: "승인" },
      { hanja: "決定", sound: "결정", meaning: "결정" },
      { hanja: "公表", sound: "공표", meaning: "공표" },
      { hanja: "實施", sound: "실시", meaning: "실시" },
      { hanja: "監視", sound: "감시", meaning: "감시" },
      { hanja: "規制", sound: "규제", meaning: "규제" },
      { hanja: "違反", sound: "위반", meaning: "위반" },
      { hanja: "處罰", sound: "처벌", meaning: "처벌" },
      { hanja: "抗議", sound: "항의", meaning: "항의" },
      { hanja: "運動", sound: "운동", meaning: "운동" },
      { hanja: "團體", sound: "단체", meaning: "단체" },
      { hanja: "參加", sound: "참가", meaning: "참가" },
      { hanja: "指導", sound: "지도", meaning: "지도" },
      { hanja: "支援", sound: "지원", meaning: "지원" },
      { hanja: "活動", sound: "활동", meaning: "활동" },
      { hanja: "組織", sound: "조직", meaning: "조직" },
      { hanja: "代表", sound: "대표", meaning: "대표" },
      { hanja: "會議", sound: "회의", meaning: "회의" },
      { hanja: "決議", sound: "결의", meaning: "결의" },
      { hanja: "聲明", sound: "성명", meaning: "성명" },
      { hanja: "主張", sound: "주장", meaning: "주장" },
      { hanja: "批判", sound: "비판", meaning: "비판" },
      { hanja: "反對", sound: "반대", meaning: "반대" },
      { hanja: "賛成", sound: "찬성", meaning: "찬성" },
      { hanja: "結束", sound: "종결", meaning: "종결" },
    ],
    경제: [
      { hanja: "經濟", sound: "경제", meaning: "경제" },
      { hanja: "投資", sound: "투자", meaning: "투자" },
      { hanja: "市場", sound: "시장", meaning: "시장" },
      { hanja: "企業", sound: "기업", meaning: "기업" },
      { hanja: "金融", sound: "금융", meaning: "금융" },
      { hanja: "貿易", sound: "무역", meaning: "무역" },
      { hanja: "産業", sound: "산업", meaning: "산업" },
      { hanja: "生産", sound: "생산", meaning: "생산" },
      { hanja: "消費", sound: "소비", meaning: "소비" },
      { hanja: "流通", sound: "유통", meaning: "유통" },
      { hanja: "資本", sound: "자본", meaning: "자본" },
      { hanja: "利潤", sound: "이윤", meaning: "이윤" },
      { hanja: "損失", sound: "손실", meaning: "손실" },
      { hanja: "資産", sound: "자산", meaning: "자산" },
      { hanja: "負債", sound: "부채", meaning: "부채" },
      { hanja: "銀行", sound: "은행", meaning: "은행" },
      { hanja: "貸款", sound: "대출", meaning: "대출" },
      { hanja: "利息", sound: "이자", meaning: "이자" },
      { hanja: "預金", sound: "예금", meaning: "예금" },
      { hanja: "通貨", sound: "통화", meaning: "통화" },
      { hanja: "兌換", sound: "태환", meaning: "태환" },
      { hanja: "匯率", sound: "환율", meaning: "환율" },
      { hanja: "價格", sound: "가격", meaning: "가격" },
      { hanja: "供給", sound: "공급", meaning: "공급" },
      { hanja: "需要", sound: "수요", meaning: "수요" },
      { hanja: "競爭", sound: "경쟁", meaning: "경쟁" },
      { hanja: "獨占", sound: "독점", meaning: "독점" },
      { hanja: "契約", sound: "계약", meaning: "계약" },
      { hanja: "取引", sound: "거래", meaning: "거래" },
      { hanja: "仲介", sound: "중개", meaning: "중개" },
      { hanja: "運輸", sound: "운수", meaning: "운수" },
      { hanja: "物流", sound: "물류", meaning: "물류" },
      { hanja: "倉庫", sound: "창고", meaning: "창고" },
      { hanja: "稅金", sound: "세금", meaning: "세금" },
      { hanja: "關稅", sound: "관세", meaning: "관세" },
      { hanja: "補助", sound: "보조", meaning: "보조" },
      { hanja: "予算", sound: "예산", meaning: "예산" },
      { hanja: "決算", sound: "결산", meaning: "결산" },
      { hanja: "會計", sound: "회계", meaning: "회계" },
      { hanja: "監査", sound: "감사", meaning: "감사" },
      { hanja: "經營", sound: "경영", meaning: "경영" },
      { hanja: "戰略", sound: "전략", meaning: "전략" },
      { hanja: "計劃", sound: "계획", meaning: "계획" },
      { hanja: "組織", sound: "조직", meaning: "조직" },
      { hanja: "管理", sound: "관리", meaning: "관리" },
      { hanja: "效率", sound: "효율", meaning: "효율" },
      { hanja: "技術", sound: "기술", meaning: "기술" },
      { hanja: "革新", sound: "혁신", meaning: "혁신" },
      { hanja: "開發", sound: "개발", meaning: "개발" },
      { hanja: "製品", sound: "제품", meaning: "제품" },
      { hanja: "品質", sound: "품질", meaning: "품질" },
      { hanja: "規格", sound: "규격", meaning: "규격" },
      { hanja: "販賣", sound: "판매", meaning: "판매" },
      { hanja: "廣告", sound: "광고", meaning: "광고" },
      { hanja: "宣傳", sound: "선전", meaning: "선전" },
      { hanja: "顧客", sound: "고객", meaning: "고객" },
      { hanja: "滿意", sound: "만족", meaning: "만족" },
      { hanja: "信用", sound: "신용", meaning: "신용" },
      { hanja: "評價", sound: "평가", meaning: "평가" },
      { hanja: "統計", sound: "통계", meaning: "통계" },
      { hanja: "調査", sound: "조사", meaning: "조사" },
      { hanja: "分析", sound: "분석", meaning: "분석" },
      { hanja: "予測", sound: "예측", meaning: "예측" },
      { hanja: "成長", sound: "성장", meaning: "성장" },
      { hanja: "衰退", sound: "쇠퇴", meaning: "쇠퇴" },
      { hanja: "危機", sound: "위기", meaning: "위기" },
      { hanja: "安定", sound: "안정", meaning: "안정" },
      { hanja: "失業", sound: "실업", meaning: "실업" },
      { hanja: "就業", sound: "취업", meaning: "취업" },
      { hanja: "勞動", sound: "노동", meaning: "노동" },
      { hanja: "賃金", sound: "임금", meaning: "임금" },
      { hanja: "福利", sound: "복리", meaning: "복리" },
      { hanja: "保險", sound: "보험", meaning: "보험" },
      { hanja: "年金", sound: "연금", meaning: "연금" },
      { hanja: "債務", sound: "채무", meaning: "채무" },
      { hanja: "破産", sound: "파산", meaning: "파산" },
      { hanja: "合併", sound: "합병", meaning: "합병" },
      { hanja: "分割", sound: "분할", meaning: "분할" },
      { hanja: "株式", sound: "주식", meaning: "주식" },
      { hanja: "債券", sound: "채권", meaning: "채권" },
      { hanja: "市場價", sound: "시장가", meaning: "시장 가격" },
      { hanja: "投機", sound: "투기", meaning: "투기" },
      { hanja: "風險", sound: "위험", meaning: "위험" },
      { hanja: "收益", sound: "수익", meaning: "수익" },
      { hanja: "費用", sound: "비용", meaning: "비용" },
      { hanja: "節約", sound: "절약", meaning: "절약" },
      { hanja: "資源", sound: "자원", meaning: "자원" },
      { hanja: "環境", sound: "환경", meaning: "환경" },
      { hanja: "持続", sound: "지속", meaning: "지속" },
      { hanja: "農業", sound: "농업", meaning: "농업" },
      { hanja: "漁業", sound: "어업", meaning: "어업" },
      { hanja: "鉱業", sound: "광업", meaning: "광업" },
      { hanja: "製造", sound: "제조", meaning: "제조" },
      { hanja: "輸出", sound: "수출", meaning: "수출" },
      { hanja: "輸入", sound: "수입", meaning: "수입" },
      { hanja: "均衡", sound: "균형", meaning: "균형" },
      { hanja: "調整", sound: "조정", meaning: "조정" },
      { hanja: "規制", sound: "규제", meaning: "규제" },
      { hanja: "自由化", sound: "자유화", meaning: "자유화" },
    ],
    사회: [
      { hanja: "社會", sound: "사회", meaning: "사회" },
      { hanja: "教育", sound: "교육", meaning: "교육" },
      { hanja: "文化", sound: "문화", meaning: "문화" },
      { hanja: "階層", sound: "계층", meaning: "계층" },
      { hanja: "人口", sound: "인구", meaning: "인구" },
      { hanja: "環境", sound: "환경", meaning: "환경" },
      { hanja: "家庭", sound: "가정", meaning: "가정" },
      { hanja: "結婚", sound: "결혼", meaning: "결혼" },
      { hanja: "離婚", sound: "이혼", meaning: "이혼" },
      { hanja: "出産", sound: "출산", meaning: "출산" },
      { hanja: "養育", sound: "양육", meaning: "양육" },
      { hanja: "老人", sound: "노인", meaning: "노인" },
      { hanja: "福祉", sound: "복지", meaning: "복지" },
      { hanja: "健康", sound: "건강", meaning: "건강" },
      { hanja: "醫療", sound: "의료", meaning: "의료" },
      { hanja: "疾病", sound: "질병", meaning: "질병" },
      { hanja: "治療", sound: "치료", meaning: "치료" },
      { hanja: "病院", sound: "병원", meaning: "병원" },
      { hanja: "保險", sound: "보험", meaning: "보험" },
      { hanja: "安全", sound: "안전", meaning: "안전" },
      { hanja: "犯罪", sound: "범죄", meaning: "범죄" },
      { hanja: "暴力", sound: "폭력", meaning: "폭력" },
      { hanja: "被害", sound: "피해", meaning: "피해" },
      { hanja: "加害", sound: "가해", meaning: "가해" },
      { hanja: "裁判", sound: "재판", meaning: "재판" },
      { hanja: "法律", sound: "법률", meaning: "법률" },
      { hanja: "正義", sound: "정의", meaning: "정의" },
      { hanja: "人權", sound: "인권", meaning: "인권" },
      { hanja: "自由", sound: "자유", meaning: "자유" },
      { hanja: "平等", sound: "평등", meaning: "평등" },
      { hanja: "差別", sound: "차별", meaning: "차별" },
      { hanja: "偏見", sound: "편견", meaning: "편견" },
      { hanja: "貧困", sound: "빈곤", meaning: "빈곤" },
      { hanja: "富裕", sound: "부유", meaning: "부유" },
      { hanja: "失業", sound: "실업", meaning: "실업" },
      { hanja: "就業", sound: "취업", meaning: "취업" },
      { hanja: "勞動", sound: "노동", meaning: "노동" },
      { hanja: "賃金", sound: "임금", meaning: "임금" },
      { hanja: "罷業", sound: "파업", meaning: "파업" },
      { hanja: "團體", sound: "단체", meaning: "단체" },
      { hanja: "組織", sound: "조직", meaning: "조직" },
      { hanja: "運動", sound: "운동", meaning: "운동" },
      { hanja: "抗議", sound: "항의", meaning: "항의" },
      { hanja: "改革", sound: "개혁", meaning: "개혁" },
      { hanja: "進步", sound: "진보", meaning: "진보" },
      { hanja: "保守", sound: "보수", meaning: "보수" },
      { hanja: "傳統", sound: "전통", meaning: "전통" },
      { hanja: "風俗", sound: "풍속", meaning: "풍속" },
      { hanja: "習慣", sound: "습관", meaning: "습관" },
      { hanja: "言語", sound: "언어", meaning: "언어" },
      { hanja: "交流", sound: "교류", meaning: "교류" },
      { hanja: "情報", sound: "정보", meaning: "정보" },
      { hanja: "通信", sound: "통신", meaning: "통신" },
      { hanja: "放送", sound: "방송", meaning: "방송" },
      { hanja: "新聞", sound: "신문", meaning: "신문" },
      { hanja: "出版", sound: "출판", meaning: "출판" },
      { hanja: "圖書", sound: "도서", meaning: "도서" },
      { hanja: "知識", sound: "지식", meaning: "지식" },
      { hanja: "學習", sound: "학습", meaning: "학습" },
      { hanja: "學校", sound: "학교", meaning: "학교" },
      { hanja: "學生", sound: "학생", meaning: "학생" },
      { hanja: "教師", sound: "교사", meaning: "교사" },
      { hanja: "授業", sound: "수업", meaning: "수업" },
      { hanja: "試験", sound: "시험", meaning: "시험" },
      { hanja: "成績", sound: "성적", meaning: "성적" },
      { hanja: "卒業", sound: "졸업", meaning: "졸업" },
      { hanja: "進學", sound: "진학", meaning: "진학" },
      { hanja: "職業", sound: "직업", meaning: "직업" },
      { hanja: "技術", sound: "기술", meaning: "기술" },
      { hanja: "訓練", sound: "훈련", meaning: "훈련" },
      { hanja: "資格", sound: "자격", meaning: "자격" },
      { hanja: "證書", sound: "증서", meaning: "증서" },
      { hanja: "都市", sound: "도시", meaning: "도시" },
      { hanja: "農村", sound: "농촌", meaning: "농촌" },
      { hanja: "地域", sound: "지역", meaning: "지역" },
      { hanja: "交通", sound: "교통", meaning: "교통" },
      { hanja: "住宅", sound: "주택", meaning: "주택" },
      { hanja: "建築", sound: "건축", meaning: "건축" },
      { hanja: "施設", sound: "시설", meaning: "시설" },
      { hanja: "公園", sound: "공원", meaning: "공원" },
      { hanja: "娛樂", sound: "오락", meaning: "오락" },
      { hanja: "旅行", sound: "여행", meaning: "여행" },
      { hanja: "觀光", sound: "관광", meaning: "관광" },
      { hanja: "休養", sound: "휴양", meaning: "휴양" },
      { hanja: "運動場", sound: "운동장", meaning: "운동장" },
      { hanja: "競技", sound: "경기", meaning: "경기" },
      { hanja: "選手", sound: "선수", meaning: "선수" },
      { hanja: "優勝", sound: "우승", meaning: "우승" },
      { hanja: "記録", sound: "기록", meaning: "기록" },
      { hanja: "歷史", sound: "역사", meaning: "역사" },
      { hanja: "遺産", sound: "유산", meaning: "유산" },
      { hanja: "記念", sound: "기념", meaning: "기념" },
      { hanja: "祭事", sound: "제사", meaning: "제사" },
      { hanja: "行事", sound: "행사", meaning: "행사" },
      { hanja: "祝賀", sound: "축하", meaning: "축하" },
      { hanja: "參加", sound: "참가", meaning: "참가" },
      { hanja: "共同", sound: "공동", meaning: "공동" },
      { hanja: "連帶", sound: "연대", meaning: "연대" },
      { hanja: "協力", sound: "협력", meaning: "협력" },
    ],
    종교: [
      { hanja: "宗教", sound: "종교", meaning: "종교" },
      { hanja: "信仰", sound: "신앙", meaning: "믿음" },
      { hanja: "儀式", sound: "의식", meaning: "의식" },
      { hanja: "神聖", sound: "신성", meaning: "신성" },
      { hanja: "祈禱", sound: "기도", meaning: "기도" },
      { hanja: "祭祀", sound: "제사", meaning: "제사" },
      { hanja: "聖堂", sound: "성당", meaning: "성당" },
      { hanja: "寺院", sound: "사원", meaning: "사원" },
      { hanja: "僧侶", sound: "승려", meaning: "승려" },
      { hanja: "牧師", sound: "목사", meaning: "목사" },
      { hanja: "聖經", sound: "성경", meaning: "성경" },
      { hanja: "佛經", sound: "불경", meaning: "불경" },
      { hanja: "教理", sound: "교리", meaning: "교리" },
      { hanja: "教義", sound: "교의", meaning: "교의" },
      { hanja: "教會", sound: "교회", meaning: "교회" },
      { hanja: "宗派", sound: "종파", meaning: "종파" },
      { hanja: "修行", sound: "수행", meaning: "수행" },
      { hanja: "冥想", sound: "명상", meaning: "명상" },
      { hanja: "悟道", sound: "오도", meaning: "깨달음" },
      { hanja: "解脫", sound: "해탈", meaning: "해탈" },
      { hanja: "輪廻", sound: "윤회", meaning: "윤회" },
      { hanja: "業報", sound: "업보", meaning: "업보" },
      { hanja: "因果", sound: "인과", meaning: "인과" },
      { hanja: "慈悲", sound: "자비", meaning: "자비" },
      { hanja: "救濟", sound: "구제", meaning: "구제" },
      { hanja: "救世", sound: "구세", meaning: "구세" },
      { hanja: "贖罪", sound: "속죄", meaning: "속죄" },
      { hanja: "罪惡", sound: "죄악", meaning: "죄악" },
      { hanja: "悔改", sound: "회개", meaning: "회개" },
      { hanja: "祝福", sound: "축복", meaning: "축복" },
      { hanja: "神靈", sound: "신령", meaning: "신령" },
      { hanja: "天使", sound: "천사", meaning: "천사" },
      { hanja: "惡魔", sound: "악마", meaning: "악마" },
      { hanja: "天堂", sound: "천당", meaning: "천당" },
      { hanja: "地獄", sound: "지옥", meaning: "지옥" },
      { hanja: "來世", sound: "내세", meaning: "내세" },
      { hanja: "永生", sound: "영생", meaning: "영생" },
      { hanja: "復活", sound: "부활", meaning: "부활" },
      { hanja: "審判", sound: "심판", meaning: "심판" },
      { hanja: "創造", sound: "창조", meaning: "창조" },
      { hanja: "宇宙", sound: "우주", meaning: "우주" },
      { hanja: "自然", sound: "자연", meaning: "자연" },
      { hanja: "神話", sound: "신화", meaning: "신화" },
      { hanja: "傳說", sound: "전설", meaning: "전설" },
      { hanja: "聖人", sound: "성인", meaning: "성인" },
      { hanja: "先知", sound: "선지", meaning: "예언자" },
      { hanja: "使徒", sound: "사도", meaning: "사도" },
      { hanja: "信徒", sound: "신도", meaning: "신도" },
      { hanja: "布教", sound: "포교", meaning: "포교" },
      { hanja: "傳道", sound: "전도", meaning: "전도" },
      { hanja: "講義", sound: "강의", meaning: "강의" },
      { hanja: "説教", sound: "설교", meaning: "설교" },
      { hanja: "讚美", sound: "찬미", meaning: "찬미" },
      { hanja: "聖歌", sound: "성가", meaning: "성가" },
      { hanja: "奉仕", sound: "봉사", meaning: "봉사" },
      { hanja: "慈善", sound: "자선", meaning: "자선" },
      { hanja: "寄付", sound: "기부", meaning: "기부" },
      { hanja: "聖物", sound: "성물", meaning: "성물" },
      { hanja: "遺物", sound: "유물", meaning: "유물" },
      { hanja: "聖地", sound: "성지", meaning: "성지" },
      { hanja: "巡禮", sound: "순례", meaning: "순례" },
      { hanja: "祭壇", sound: "제단", meaning: "제단" },
      { hanja: "供物", sound: "공물", meaning: "공물" },
      { hanja: "燭台", sound: "촉대", meaning: "촛대" },
      { hanja: "香爐", sound: "향로", meaning: "향로" },
      { hanja: "法衣", sound: "법의", meaning: "법의" },
      { hanja: "聖像", sound: "성상", meaning: "성상" },
      { hanja: "偶像", sound: "우상", meaning: "우상" },
      { hanja: "禁忌", sound: "금기", meaning: "금기" },
      { hanja: "神秘", sound: "신비", meaning: "신비" },
      { hanja: "奇跡", sound: "기적", meaning: "기적" },
      { hanja: "預言", sound: "예언", meaning: "예언" },
      { hanja: "啓示", sound: "계시", meaning: "계시" },
      { hanja: "幻影", sound: "환영", meaning: "환영" },
      { hanja: "靈魂", sound: "영혼", meaning: "영혼" },
      { hanja: "超自然", sound: "초자연", meaning: "초자연" },
      { hanja: "祭日", sound: "제일", meaning: "제일" },
      { hanja: "行事", sound: "행사", meaning: "행사" },
      { hanja: "祝日", sound: "축일", meaning: "축일" },
      { hanja: "安息", sound: "안식", meaning: "안식" },
      { hanja: "平和", sound: "평화", meaning: "평화" },
      { hanja: "和解", sound: "화해", meaning: "화해" },
      { hanja: "共存", sound: "공존", meaning: "공존" },
      { hanja: "寬容", sound: "관용", meaning: "관용" },
      { hanja: "迫害", sound: "박해", meaning: "박해" },
      { hanja: "異端", sound: "이단", meaning: "이단" },
      { hanja: "迷信", sound: "미신", meaning: "미신" },
      { hanja: "邪教", sound: "사교", meaning: "사교" },
      { hanja: "教團", sound: "교단", meaning: "교단" },
      { hanja: "指導", sound: "지도", meaning: "지도" },
      { hanja: "教育", sound: "교육", meaning: "교육" },
      { hanja: "倫理", sound: "윤리", meaning: "윤리" },
      { hanja: "道德", sound: "도덕", meaning: "도덕" },
      { hanja: "規範", sound: "규범", meaning: "규범" },
      { hanja: "秩序", sound: "질서", meaning: "질서" },
      { hanja: "理想", sound: "이상", meaning: "이상" },
      { hanja: "希望", sound: "희망", meaning: "희망" },
      { hanja: "絶望", sound: "절망", meaning: "절망" },
      { hanja: "人生", sound: "인생", meaning: "인생" },
    ],
    과학: [
      { hanja: "科學", sound: "과학", meaning: "과학" },
      { hanja: "技術", sound: "기술", meaning: "기술" },
      { hanja: "實驗", sound: "실험", meaning: "실험" },
      { hanja: "研究", sound: "연구", meaning: "연구" },
      { hanja: "發明", sound: "발명", meaning: "발명" },
      { hanja: "發現", sound: "발견", meaning: "발견" },
      { hanja: "理論", sound: "이론", meaning: "이론" },
      { hanja: "假設", sound: "가설", meaning: "가설" },
      { hanja: "證明", sound: "증명", meaning: "증명" },
      { hanja: "分析", sound: "분석", meaning: "분석" },
      { hanja: "觀察", sound: "관찰", meaning: "관찰" },
      { hanja: "調査", sound: "조사", meaning: "조사" },
      { hanja: "測定", sound: "측정", meaning: "측정" },
      { hanja: "計算", sound: "계산", meaning: "계산" },
      { hanja: "數學", sound: "수학", meaning: "수학" },
      { hanja: "物理", sound: "물리", meaning: "물리" },
      { hanja: "化學", sound: "화학", meaning: "화학" },
      { hanja: "生物", sound: "생물", meaning: "생물" },
      { hanja: "地質", sound: "지질", meaning: "지질" },
      { hanja: "天文", sound: "천문", meaning: "천문" },
      { hanja: "宇宙", sound: "우주", meaning: "우주" },
      { hanja: "星雲", sound: "성운", meaning: "성운" },
      { hanja: "惑星", sound: "혹성", meaning: "혹성" },
      { hanja: "太陽", sound: "태양", meaning: "태양" },
      { hanja: "月蝕", sound: "월식", meaning: "월식" },
      { hanja: "地球", sound: "지구", meaning: "지구" },
      { hanja: "大氣", sound: "대기", meaning: "대기" },
      { hanja: "氣候", sound: "기후", meaning: "기후" },
      { hanja: "海洋", sound: "해양", meaning: "해양" },
      { hanja: "生態", sound: "생태", meaning: "생태" },
      { hanja: "進化", sound: "진화", meaning: "진화" },
      { hanja: "遺傳", sound: "유전", meaning: "유전" },
      { hanja: "細胞", sound: "세포", meaning: "세포" },
      { hanja: "器官", sound: "기관", meaning: "기관" },
      { hanja: "組織", sound: "조직", meaning: "조직" },
      { hanja: "細菌", sound: "세균", meaning: "세균" },
      { hanja: "感染源", sound: "감염원", meaning: "감염원" },
      { hanja: "免疫", sound: "면역", meaning: "면역" },
      { hanja: "醫學", sound: "의학", meaning: "의학" },
      { hanja: "藥品", sound: "약품", meaning: "약품" },
      { hanja: "治療", sound: "치료", meaning: "치료" },
      { hanja: "手術", sound: "수술", meaning: "수술" },
      { hanja: "機械", sound: "기계", meaning: "기계" },
      { hanja: "電子", sound: "전자", meaning: "전자" },
      { hanja: "電氣", sound: "전기", meaning: "전기" },
      { hanja: "電力", sound: "전력", meaning: "전력" },
      { hanja: "動力", sound: "동력", meaning: "동력" },
      { hanja: "燃料", sound: "연료", meaning: "연료" },
      { hanja: "原子", sound: "원자", meaning: "원자" },
      { hanja: "分子", sound: "분자", meaning: "분자" },
      { hanja: "反應", sound: "반응", meaning: "반응" },
      { hanja: "合成", sound: "합성", meaning: "합성" },
      { hanja: "分解", sound: "분해", meaning: "분해" },
      { hanja: "物質", sound: "물질", meaning: "물질" },
      { hanja: "元素", sound: "원소", meaning: "원소" },
      { hanja: "化合物", sound: "화합물", meaning: "화합물" },
      { hanja: "酸素", sound: "산소", meaning: "산소" },
      { hanja: "窒素", sound: "질소", meaning: "질소" },
      { hanja: "炭素", sound: "탄소", meaning: "탄소" },
      { hanja: "金属", sound: "금속", meaning: "금속" },
      { hanja: "合金", sound: "합금", meaning: "합금" },
      { hanja: "結晶", sound: "결정", meaning: "결정" },
      { hanja: "構造", sound: "구조", meaning: "구조" },
      { hanja: "機能", sound: "기능", meaning: "기능" },
      { hanja: "設計", sound: "설계", meaning: "설계" },
      { hanja: "製造", sound: "제조", meaning: "제조" },
      { hanja: "製品", sound: "제품", meaning: "제품" },
      { hanja: "品質", sound: "품질", meaning: "품질" },
      { hanja: "規格", sound: "규격", meaning: "규격" },
      { hanja: "標準", sound: "표준", meaning: "표준" },
      { hanja: "性能", sound: "성능", meaning: "성능" },
      { hanja: "效率", sound: "효율", meaning: "효율" },
      { hanja: "革新", sound: "혁신", meaning: "혁신" },
      { hanja: "開発", sound: "개발", meaning: "개발" },
      { hanja: "応用", sound: "응용", meaning: "응용" },
      { hanja: "情報", sound: "정보", meaning: "정보" },
      { hanja: "通信", sound: "통신", meaning: "통신" },
      { hanja: "計算機", sound: "계산기", meaning: "컴퓨터" },
      { hanja: "人工", sound: "인공", meaning: "인공" },
      { hanja: "知能", sound: "지능", meaning: "지능" },
      { hanja: "自動", sound: "자동", meaning: "자동" },
      { hanja: "制御", sound: "제어", meaning: "제어" },
      { hanja: "環境", sound: "환경", meaning: "환경" },
      { hanja: "汚染", sound: "오염", meaning: "오염" },
      { hanja: "保護", sound: "보호", meaning: "보호" },
      { hanja: "資源", sound: "자원", meaning: "자원" },
      { hanja: "循環", sound: "순환", meaning: "순환" },
      { hanja: "持続", sound: "지속", meaning: "지속" },
      { hanja: "気象", sound: "기상", meaning: "기상" },
      { hanja: "予測", sound: "예측", meaning: "예측" },
      { hanja: "災害", sound: "재해", meaning: "재해" },
      { hanja: "予防", sound: "예방", meaning: "예방" },
      { hanja: "対策", sound: "대책", meaning: "대책" },
      { hanja: "安全", sound: "안전", meaning: "안전" },
      { hanja: "危険", sound: "위험", meaning: "위험" },
      { hanja: "事故", sound: "사고", meaning: "사고" },
      { hanja: "修復", sound: "수복", meaning: "수복" },
      { hanja: "進歩", sound: "진보", meaning: "진보" },
    ],
  };

  const categories = Object.keys(hanjaData);
  const [currentCategory, setCurrentCategory] = useState(categories[0]);
  const [words, setWords] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showSound, setShowSound] = useState(false);
  const [isAuto, setIsAuto] = useState(true);
  const [unknownWords, setUnknownWords] = useState([]);
  const [isUnknownMode, setIsUnknownMode] = useState(false);
  const [interval, setInterval] = useState(3); // 기본 간격 3초

  // 분야 선택 시 단어 목록 초기화
  const handleCategoryChange = (category) => {
    setCurrentCategory(category);
    setIsUnknownMode(false);
    const shuffledWords = [...hanjaData[category]].sort(() => Math.random() - 0.5);
    setWords(shuffledWords.slice(0, 100));
    setCurrentIndex(0);
    setShowSound(false);
  };

  // 간격 변경
  const handleIntervalChange = () => {
    setInterval(prev => {
      const next = prev + 1;
      return next > 5 ? 2 : next;
    });
  };

  // 모르는 단어 학습 모드로 전환
  const handleUnknownMode = () => {
    if (unknownWords.length === 0) {
      alert("모르는 단어가 없습니다.");
      return;
    }
    setIsUnknownMode(true);
    setWords([...unknownWords]); // 새로운 배열로 설정
    setCurrentIndex(0);
    setShowSound(false);
  };

  // 초기 단어 설정
  useEffect(() => {
    handleCategoryChange(currentCategory);
  }, []);

  // 단어 전환 후 타이머 설정 (자동/수동 공통)
  useEffect(() => {
    if (words.length === 0) return;

    let soundTimer;
    let nextTimer;

    // interval 초 후 한글 음 표시
    soundTimer = setTimeout(() => {
      setShowSound(true);
      // 1초 후 음 숨기고 자동 모드일 경우 다음 단어로
      nextTimer = setTimeout(() => {
        setShowSound(false);
        if (isAuto) {
          setCurrentIndex((prev) => (prev + 1) % words.length);
        }
      }, 1000);
    }, interval * 1000);

    return () => {
      clearTimeout(soundTimer);
      clearTimeout(nextTimer);
    };
  }, [currentIndex, words, isAuto, interval]);

  // 수동으로 다음 단어로 이동
  const handleNext = () => {
    setShowSound(false);
    setCurrentIndex((prev) => (prev + 1) % words.length);
  };

  // 모르는 단어 체크
  const handleCheckUnknown = () => {
    const currentWord = words[currentIndex];
    if (!unknownWords.some((word) => word.hanja === currentWord.hanja)) {
      setUnknownWords([...unknownWords, currentWord]);
    }
  };

  // 자동 진행 토글
  const toggleAuto = () => {
    setIsAuto((prev) => !prev);
  };

  if (words.length === 0) return <div>로딩 중...</div>;

  const currentWord = words[currentIndex];

  return (
    <div className="app">
      <h1>onepage.co.kr</h1>
      <div className="category-buttons">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => handleCategoryChange(category)}
            className={currentCategory === category && !isUnknownMode ? 'active' : ''}
          >
            {category}
          </button>
        ))}
        <button
          onClick={handleUnknownMode}
          className={isUnknownMode ? 'active' : ''}
        >
          모르는 단어 학습 ({unknownWords.length})
        </button>
      </div>
      <p>분야: {isUnknownMode ? '모르는 단어' : currentCategory}</p>
      <div className="hanja-display">
        <div className="interval-selector" onClick={handleIntervalChange}>
          {interval}
        </div>
        <div className="hanja">{currentWord.hanja}</div>
        {showSound && <div className="sound show">{currentWord.sound}</div>}
      </div>
      <div className="controls">
        <button onClick={handleNext}>다음</button>
        <button onClick={toggleAuto}>{isAuto ? '자동 중지' : '자동 시작'}</button>
        <button onClick={handleCheckUnknown}>모르는 단어 체크</button>
      </div>
    </div>
  );
};

export default App;